"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Storage = _interopRequireDefault(require("./Storage"));

var DEBUG_FLAG = 'FIREALARM_DEBUG';
var storage;

try {
  var localStorage = window && window.localStorage ? window.localStorage : false;
  storage = new _Storage.default(localStorage);
} catch (e) {
  storage = new _Storage.default(false);
}

function debug(message) {
  if (storage.getItem(DEBUG_FLAG)) {
    console.log.apply(console, arguments);
  }
}

var _default = debug;
exports.default = _default;
module.exports = exports.default;